import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { push } from "redux-first-history";
import CustomButton from "../../../../components/CustomButton";
import { userSetupSlice } from "../../../../store/reducer/user_setup";
import TermsAndConditions from '../../../../components/TermsAndConditions/TermsAndConditions';
import Box from "@mui/material/Box";
import { ExitType } from "../../../../constants/common"
import { useDispatch } from "react-redux";

const AcceptTerms = () => {
  const dispatch = useDispatch();
  let [termsRead, setTermsRead] = useState(false);

  const sendToSorryScreen = () => {
    dispatch(userSetupSlice.actions.setExitMessageType(ExitType.NoTermsAcceptance));
    dispatch(push('/register/sorry'));
  };

  const handleScroll = (e: any) => {
    const scrollCounter = e.target.scrollHeight - e.target.scrollTop;
    // Reached bottom if scrollCounter is less than clientHeight or the difference between the two is less than 15 pixels 
    const reachedBottom = scrollCounter <= e.target.clientHeight || Math.abs(scrollCounter - e.target.clientHeight) < 15
    if (reachedBottom) { setTermsRead(true); }
  }

  return <ValidatorForm
    onSubmit={() => {
      dispatch(push('/register/name'));
    }}>
    <Box component="p" className="context">
      Before creating a new account you must read and accept the terms and conditions of using LIME.
    </Box>
    <div
      style={{
        marginTop: '1em',
        width: '100%',
        height: '40vh',
        overflowY: 'scroll',
        border: '1px solid #bbb',
        borderRadius: '5px',
        padding: '1em',
      }}
      onScroll={handleScroll}
    >
      <TermsAndConditions termsSigned={false} />
    </div>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: '1.7em' }}>
      <CustomButton
        buttonSize="btn-sm"
        label="Decline"
        onClick={() => sendToSorryScreen()}
      />
      <CustomButton
        variant="contained"
        disableElevation={true}
        label={"Accept"}
        buttonSize="btn-lg"
        type="submit"
        disabled={!termsRead}
      />
    </Box>
  </ValidatorForm>
};

export default AcceptTerms;
